import { __awaiter, __generator } from "tslib";
import { app, renderAsApp } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import './crytoagent';
import { init } from './init';
import { filterFromUrl as filter } from '../../lib/lib-util';
import setNetworkAdapter from '../setNetworkAdapter';
import { initColors } from '../initColors';
function startup() {
    var pluginType = filter('pluginType');
    console.log(pluginType);
    app.use(require('../../plugins/cgbpayment/index').default);
    app.callback().then(function (dom) { return renderAsApp(dom); });
}
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initColors();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, init()];
                case 2:
                    _a.sent();
                    setNetworkAdapter();
                    document.title = i18n.get("\u6613\u5FEB\u62A5@@" + Fetch.ekbCorpId, null, function () { return i18n.get('易快报专业版'); });
                    startup();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    if (e_1.type === 'login') {
                        alert(e_1.msg);
                        window.close();
                    }
                    console.log(e_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
